<script lang="ts">
  import { onMount } from 'svelte';
  import { slide, fade } from 'svelte/transition';
  import { locale, type Lang, changeLocale, loadTranslations } from '$lib/i18n';
  import { page } from '$app/stores';
  import { goto } from '$app/navigation';
  import ArrowRightIcon from "$lib/icons/ArrowRightIcon.svelte";


  const languages: Array<{ code: Lang; name: string; flag: string }> = [
    { code: 'en', name: 'English', flag: '/flags/en.png' },
    { code: 'it', name: 'Italiano', flag: '/flags/it.png' },
    { code: 'es', name: 'Español', flag: '/flags/es.png' },
    { code: 'fr', name: 'Français', flag: '/flags/fr.png' },
    { code: 'de', name: 'Deutsch', flag: '/flags/de.png' },


  ];

  let isOpen = $state(false);
  let dropdownRef: HTMLDivElement = $state();

  async function handleLanguageChange(newLang: Lang) {
    await loadTranslations(newLang, window.fetch);
    changeLocale(newLang);
    const currentPath = $page.url.pathname;
    const newPath = `/${newLang}${currentPath.slice(3)}`;
    goto(newPath, { replaceState: true });
    isOpen = false;
  }

  function toggleDropdown() {
    isOpen = !isOpen;
  }

  function handleClickOutside(event: MouseEvent) {
    if (dropdownRef && !dropdownRef.contains(event.target as Node)) {
      isOpen = false;
    }
  }

  onMount(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  });
</script>

<div class="relative" bind:this={dropdownRef}>
  <button onclick={toggleDropdown} class="flex items-center justify-between w-full text-sm font-medium focus:outline-none text-gray-200 ">
    <span class="flex items-center">
      <img class="mr-2 w-6" src={languages.find(lang => lang.code === $locale)?.flag} alt={languages.find(lang => lang.code === $locale)?.name}>
    </span>
    <ArrowRightIcon css={isOpen ? 'rotate-1' : 'rotate-90'}/>
  </button>

  {#if isOpen}
    <div transition:slide|local={{ duration: 300, axis: 'y' }} class="rotate absolute right-0 w-56 p-2 mt-3 origin-top-right rounded-lg shadow-lg focus:outline-none bg-primary-dark">
      {#each languages as language (language.code)}
        <button
          onclick={() => handleLanguageChange(language.code)}
          class="flex items-center w-full rounded-md px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 dark:text-gray-300 dark:hover:bg-gray-700 dark:hover:text-white"
          transition:fade|local={{ duration: 200 }}>
          <img class="mr-2 w-6" src={language.flag} alt={language.name}>
          <span>{language.name}</span>
        </button>
      {/each}
    </div>
  {/if}
</div>
